import { render, staticRenderFns } from "./DeleteTrainingExpenses.vue?vue&type=template&id=7f35720b&scoped=true"
import script from "./DeleteTrainingExpenses.vue?vue&type=script&lang=js"
export * from "./DeleteTrainingExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f35720b",
  null
  
)

export default component.exports